module.exports = __webpack_public_path__ + "static/media/Reading.5a54539d.png";